import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import store from "./store";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./components/ErrorBoundary";
import AppErrorFallback from "./components/ErrorBoundary/AppErrorFallback";
import {
  installGlobalChunkLoadRecovery,
  scheduleRecoveryStateReset,
} from "./utils/chunkLoadRecovery";

// Must run before render — catches script/CSS 404s and unhandled chunk rejections
installGlobalChunkLoadRecovery();
// After a clean boot, reset retry counters so the next deploy can auto-recover
scheduleRecoveryStateReset();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <CookiesProvider>
      <Provider store={store}>
        <ErrorBoundary fallback={<AppErrorFallback />}>
          <App />
        </ErrorBoundary>
      </Provider>
    </CookiesProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
